/**
 * Accent- en trema-onafhankelijk zoeken (bijv. "ismael" vindt "Ismaël").
 */
export function foldSearchText(value: string): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/ß/g, 'ss')
    .replace(/æ/gi, 'ae')
    .replace(/ø/gi, 'o')
    .replace(/ł/g, 'l')
    .toLowerCase()
    .trim();
}

/** Of `haystack` de gezochte `needle` bevat na normalisatie. */
export function searchTextIncludes(haystack: string | null | undefined, needle: string): boolean {
  const n = foldSearchText(needle);
  if (!n) return true;
  return foldSearchText(haystack ?? '').includes(n);
}

/** Of één van de velden matcht. */
export function searchTextIncludesAny(needle: string, ...haystacks: (string | null | undefined)[]): boolean {
  if (!foldSearchText(needle)) return true;
  return haystacks.some((h) => searchTextIncludes(h, needle));
}

/**
 * Ruimer ilike-patroon voor Postgres: voorfilter op prefix zonder accenten,
 * daarna client-side met {@link searchTextIncludes} verfijnen.
 */
export function searchDbIlikePattern(needle: string, minPrefix = 3): string {
  const f = foldSearchText(needle);
  if (!f) return '%';
  if (f.length <= minPrefix) return `%${f}%`;
  // Laatste tekens kunnen in de DB als accent staan (ë vs e); korter prefix voor ilike.
  const drop = f.length >= 6 ? 2 : 1;
  const prefixLen = Math.max(minPrefix, f.length - drop);
  return `%${f.slice(0, prefixLen)}%`;
}
